import React from 'react'

const EmployeeIcon: React.FC = () => (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group">
      <path
        id="Vector"
        d="M5.6345 9.34587C2.79334 9.60268 0.628782 12.0034 0.666501 14.8559V15.0005C0.666501 15.5528 1.11422 16.0005 1.6665 16.0005C2.21878 16.0005 2.6665 15.5528 2.6665 15.0005V14.8159C2.63644 13.0645 3.92894 11.5709 5.6665 11.3492C7.50066 11.1673 9.135 12.5068 9.31688 14.3409C9.32763 14.4494 9.33307 14.5583 9.33316 14.6672V15.0005C9.33316 15.5528 9.78088 16.0005 10.3332 16.0005C10.8854 16.0005 11.3332 15.5528 11.3332 15.0005V14.6672C11.3299 11.7183 8.93675 9.33049 5.98794 9.33374C5.87003 9.3339 5.75216 9.33793 5.6345 9.34587Z"
        fill="#052351"
      />
      <path
        id="Vector_2"
        d="M6 8C8.20913 8 10 6.20913 10 4C10 1.79087 8.20913 0 6 0C3.79087 0 2 1.79087 2 4C2.00219 6.20822 3.79178 7.99778 6 8ZM6 2C7.10456 2 8 2.89544 8 4C8 5.10456 7.10456 6 6 6C4.89544 6 4 5.10456 4 4C4 2.89544 4.89544 2 6 2Z"
        fill="#052351"
      />
    </g>
  </svg>
)

export default EmployeeIcon
